/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it include taxes, fees, or insurance?`)
};

const es_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Incluye impuestos, tarifas o seguros?`)
};

const de_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind Steuern, Gebühren oder Versicherungen enthalten?`)
};

const nl_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevat het belastingen, vergoedingen of verzekeringen?`)
};

const fr_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclut-il les impôts, les frais ou l'assurance?`)
};

const it_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include tasse, commissioni o assicurazione?`)
};

const pt_br2_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclui impostos, taxas ou seguro?`)
};

const pt_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclui impostos, taxas ou seguros?`)
};

const ja_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「税金、手数料、保険を含みますか？」`)
};

const zh_ln_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否包含税费、手续费或保险？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_faq2_q", locale)
	if (locale === "en") return en_ln_faq2_q(inputs)
	if (locale === "es") return es_ln_faq2_q(inputs)
	if (locale === "de") return de_ln_faq2_q(inputs)
	if (locale === "nl") return nl_ln_faq2_q(inputs)
	if (locale === "fr") return fr_ln_faq2_q(inputs)
	if (locale === "it") return it_ln_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_ln_faq2_q(inputs)
	if (locale === "pt") return pt_ln_faq2_q(inputs)
	if (locale === "ja") return ja_ln_faq2_q(inputs)
	return zh_ln_faq2_q(inputs)
};